import * as React from 'react';
import { AppState, SaveQueryState } from '../../redux';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import SaveQueryComponent, { SaveQueryFormData } from '../../components/NewReportBuilder/SaveQuery';
import { saveQueryAndChart, storeReportTitle } from '../../actions/report';
import { NotificationService } from '../../services/notificationService';
import { NOTIFICATION_ERROR, NOTIFICATION_SUCCESS } from '../../constants';
import { Chart } from '../../types/chartModel';
import { SavedQuery } from '../../types/savedQueryModel';
import { AuthService } from '../../services/authService';
import { SuggestedReportService } from '../../services/suggestedReportService';
import { storeSavedQuery } from '../../actions/savedQueries';
import {
  apiGetUserCapabilitiesForReport,
  UserCapabilitiesType,
  defaultUserCapabilities
} from '../../services/reportService';
export interface SaveQueryContainerProps {
  dispatch: Dispatch<any>;
  saveQueryState: SaveQueryState;
  notificationService: NotificationService;
  chart: Chart;
  loadedQuery?: SavedQuery;
  disabled?: boolean;
  authService: AuthService;
  saveAs: boolean;
  showModal: boolean;
  setShowModal: (showModal: boolean, saveAs: boolean) => void;
  readOnly: boolean;
}

export interface SaveQueryContainerState {
  userCapabilities: UserCapabilitiesType;
}

const mapStateToProps = (state: AppState) => ({
  saveQueryState: state.saveQuery,
  notificationService: state.notificationService,
  chart: state.chart,
  authService: state.authService
});

class SaveQueryContainer extends React.Component<SaveQueryContainerProps, SaveQueryContainerState> {
  protected suggestedReportService: SuggestedReportService;

  constructor(props: SaveQueryContainerProps) {
    super(props);
    this.state = {
      userCapabilities: defaultUserCapabilities,
    };

    this.suggestedReportService = SuggestedReportService.getInstance();
  }

  onSaveClicked = async (formData: SaveQueryFormData, saveAs: boolean) => {
    try {
      const query: SavedQuery | undefined = await this.props.dispatch(
        saveQueryAndChart(saveAs, this.props.loadedQuery, this.props.chart, formData)
      );
      
      if (!query) {
        throw new Error();
      }

      // Populate the report title with the inputted title
      this.props.dispatch(storeReportTitle(formData.name));
      this.props.dispatch(storeSavedQuery(query));
      this.props.notificationService.addNotification(NOTIFICATION_SUCCESS, 'Report saved');
    } catch (e) {
      this.props.notificationService.addNotification(NOTIFICATION_ERROR, 'Failed to save report');
    } finally {
      this.props.setShowModal(false, false);
    }
  }

  async componentDidMount() {
    const user = this.props.authService.getUserData();

    try {
      if (user) {
        const userCapabilities = await apiGetUserCapabilitiesForReport(user.id);
        this.setState({ userCapabilities });
      }
    } catch (e) {
      // console.log(e);
    }
  }

  render() {
    let canSaveSuggestions: boolean = this.suggestedReportService.hasSuggestionsCapabilities(this.props.authService);
    return (
      <SaveQueryComponent
        onSaveClicked={this.onSaveClicked}
        saving={this.props.saveQueryState.saving}
        showSaveError={this.props.saveQueryState.showSaveError}
        showModal={this.props.showModal}
        setShowModal={this.props.setShowModal}
        disabled={this.props.disabled}
        canSaveSuggestions={canSaveSuggestions}
        loadedQuery={this.props.loadedQuery}
        userCapabilities={this.state.userCapabilities}
        saveAs={this.props.saveAs || this.props.readOnly}
        readOnly={this.props.readOnly}
      />
    );
  }
}

const SaveQuery = connect(
  mapStateToProps)(SaveQueryContainer);
export default SaveQuery;
